import {
    take,
    fork,
    call,
    put,
    select,
    all,
} from 'redux-saga/effects';

import { apiPost } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import { failJoinToSport } from '../actionCreators/joinToSport';

import apiRoutes from '../../constants/apiRoutes';
import { requestProgressiveMissions } from "../actionCreators/progressiveMissions";
import { requestGameBoxMission } from "../actionCreators/gameBoxMission";

function* joinToSport(data: any): any {
    try {
        const headers = {};
        let params = {};
        const token = yield select(getToken);

        if (token) {
            params['token'] = token;
            headers['x-access-token'] = JSON.stringify(token);
        }

        if (data?.payload) {
            params = { ...params, ...data.payload };
        }

        const response = yield call(apiPost, 'REACT_APP_GAMEBOX_URL', apiRoutes.SPORT_TEAM_TO_START, params, headers);

        if (response.data.success && response.data.result) {
            yield all([
                put(requestProgressiveMissions()),
                put(requestGameBoxMission()),
            ]);
        } else {
            yield put(failJoinToSport(response?.statusText));
        }
    } catch (e) {
        yield put(failJoinToSport(e));
    }
}

export default function* watchJoinTOSportRequest():any {
    while (true) {
        const action = yield take(actionTypes.JOIN_TO_SPORT_REQUEST);
        yield fork(joinToSport, action);
    }
}
